import React, { Component } from 'react';
import { formatVietnameseDate } from '@/utils/helpers';
import moment from 'moment';

class PrintRepresentative extends Component {

    render() {
        const { customer, data } = this.props;

        return (
            <div>
                <div className="print-container">
                    {/* Header */}
                    <div className="header">
                        <div className="header-left">
                            Công ty TNHH Anh Nguyễn Beauty
                            <br />
                            Cơ sở KB, CB: Nha khoa CHINGO
                        </div>
                        <div className="header-center">
                            <div className="header-title">
                                CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
                                <br />
                                <span className="subtitle">Độc lập - Tự do - Hạnh phúc</span>
                            </div>
                        </div>
                        <div className="header-right">MS: HC-03</div>
                    </div>
                    <h2 className="form-title">
                        GIẤY ĐỀ NGHỊ
                        <br />
                        Làm người đại diện cho người bệnh
                    </h2>

                    <p style={{ marginTop: 30 }}>
                        Tôi tên là: .....................................................................
                        Tuổi:................................&nbsp;&nbsp;
                        <input type="checkbox" /> Nam
                        &nbsp;&nbsp;
                        <input type="checkbox" /> Nữ
                    </p>
                    <p>
                        Số Căn cước/Hộ chiếu:..................................
                        Ngày cấp: ......../............../.................<br />
                        Nơi cấp:..........................................................................................................................
                    </p>
                    <p>
                        Địa chỉ: ....................................................................................................................................
                    </p>
                    <p>
                        Điện thoại:......................................
                    </p>
                    <p>
                        Tôi là:	.....................................................
                        của người bệnh:..............................................
                        Tuổi............
                    </p>
                    <p>
                        Nhập viện ngày ........./........./20.........
                        Số vào viện/Mã người bệnh:............................................
                    </p>
                    <p>
                        Hiện nay, người bệnh không có người đại diện hoặc có người đại diện là Ông/Bà.......................................
                    </p>
                    <p>
                        là..............................
                        của người bệnh nhưng hiện tại không thể quyết định việc khám bệnh, chữa bệnh cho người bệnh. Và người bệnh đang trong tình trạng:
                    </p>
                    <p className='text-indent'>
                        <input type="checkbox" /> Chưa đủ 18 tuổi.
                    </p>
                    <p className='text-indent'>
                        <input type="checkbox" /> Mất năng lực hành vi dân sự.
                    </p>
                    <p className='text-indent'>
                        <input type="checkbox" /> Hạn chế năng lực hành vi dân sự.
                    </p>
                    <p className='text-indent'>
                        <input type="checkbox" /> Có khó khăn trong nhận thức, làm chủ hành vi.
                    </p>

                    <p>
                        Do đó, tôi tự nguyện làm người đại diện cho người bệnh để:
                    </p>
                    <p className='text-indent'>
                        <input type="checkbox" /> Trực tiếp gặp, nghe bác sỹ, nhân viên y tế của đơn vị giải thích về tình trạng sức khỏe người bệnh.
                    </p>
                    <p className='text-indent'>
                        <input type="checkbox" />  Quyết định/thay đổi/chấm dứt phương pháp điều trị cho người bệnh theo tư vấn, chỉ định của các y, bác sỹ.
                    </p>
                    <p className='text-indent'>
                        <input type="checkbox" /> Quyết định và làm thủ tục xuất viện, chuyển viện.
                    </p>
                    <p className='text-indent'>
                        <input type="checkbox" /> Ký các giấy tờ và thực hiện các thủ tục theo quy định của cơ sở khám bệnh, chữa bệnh.
                    </p>
                    <p className='text-indent'>
                        <input type="checkbox" /> Thanh toán viện phí và nhận các khoản tiền cơ sở khám bệnh, chữa bệnh hoàn trả.
                    </p>
                    <p className='text-indent'>
                        <input type="checkbox" /> Nội dung khác:..........................................................................................................
                    </p>

                    <p>
                        Tôi cam kết rằng tôi hoàn toàn minh mẫn, sáng suốt và tự nguyện thực hiện các công việc trên vì lợi ích của người bệnh.
                    </p>
                    <p>
                        Tôi cam kết rằng các thông tin tôi cung cấp ở trên là sự thật và sẽ hoàn toàn chịu trách nhiệm trước người bệnh và các cá nhân, cơ quan, tổ chức khác về các công việc tôi đã đại diện thực hiện.

                    </p>
                    <p className="signature-block">
                        <span></span>
                        <span></span>
                        <span>
                            {/* Ngày {formatVietnameseDate(moment().format('DD/MM/YYYY'))} */}
                            Ngày ........ tháng ........ năm ........
                            <br />
                            <b>Người đề nghị</b>
                            <br />
                            (Ký, ghi rõ họ tên)
                        </span>
                    </p>
                </div>
                <style>
                    {`
                        @page {
                            size: A4;
                            margin: 1cm 1.2cm 1cm 1.8cm;
                            /* top, right, bottom, left */
                        }

                        :root {
                            --text: #111;
                            --muted: #666;
                            --border: #ddd;
                            --heading: #000;
                            --primary: #0b2b33;
                        }

                        @media print {
                            .no-print {
                                display: none !important;
                            }

                            .page-break {
                                page-break-before: always;
                            }

                            html,
                            body {
                                margin: 0 auto;
                                padding: 0;
                            }
                        }
                        .print-container {
                            width: 100%;
                            font-family: "Times New Roman", serif;
                            font-size: 12pt;
                            line-height: 1.3;
                            color: #000;
                            page-break-after: always;
                            word-wrap: break-word;
                        }

                        /* ===== HEADER ===== */
                        .print-container .header {
                            display: grid;
                            grid-template-columns: 0.8fr 2fr 0.8fr;
                            /* cột giữa rộng hơn */
                            align-items: start;
                            column-gap: 4mm;
                            margin-bottom: 6mm;
                        }

                        .print-container .header-left {
                            font-size: 11pt;
                            line-height: 1.4;
                        }

                        .print-container .header-center {
                            text-align: center;
                        }

                        .print-container .header-title {
                            font-weight: bold;
                            font-size: 13pt;
                            line-height: 1.35;
                        }

                        .print-container .header-title .subtitle {
                            font-weight: normal;
                            font-size: 12pt;
                        }

                        .print-container .header-right {
                            text-align: right;
                            font-weight: bold;
                            font-size: 11pt;
                        }

                        /* ===== TITLE ===== */
                        .print-container .form-title {
                            text-align: center;
                            font-size: 13pt;
                            font-weight: bold;
                            margin: 0;
                            line-height: 1.5;
                        }

                        .print-container .form-subtitle {
                            text-align: center;
                            margin-bottom: 5mm;
                        }

                        .print-container .form-subtitle label {
                            margin: 0 5mm;
                        }

                        /* ===== CONTENT ===== */
                        .print-container p {
                            margin: 2mm 0;
                            text-align: left;
                        }

                        .print-container ul.checklist {
                            list-style: none;
                            padding-left: 0;
                            margin: 2mm 0;
                        }

                        .print-container ul.checklist li {
                            margin-bottom: 2mm;
                        }

                        .print-container .checkbox-group {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 6mm;
                            margin-bottom: 3mm;
                        }

                        .print-container input[type="checkbox"] {
                            width: 18px;
                            height: 18px;
                            margin: 0;
                            position: relative;
                            bottom: -2px;
                        }

                        .print-container .checkbox-group label {
                            white-space: nowrap;
                        }

                        /* ===== SIGNATURE BLOCK ===== */
                        .print-container .signature-block {
                            display: grid;
                            grid-template-columns: 1fr 1fr 1fr;
                            text-align: center;
                            margin-top: 2mm;
                            font-size: 12pt;
                        }

                        .print-container .signature-block span {
                            display: inline-block;
                            line-height: 1.6;
                        }

                        .print-container .line {
                            height: 5mm;
                            border-bottom: 0.3pt dotted #000;
                            margin: 0.8mm 0;
                        }

                        .w-150{
                            width: 150px;
                        }

                        .w-200{
                            width: 200px;
                        }

                        .text-indent{
                            text-indent: 20px;
                        }
                    `}
                </style>
            </div >
        );
    }
}

export default PrintRepresentative;
